import React from 'react';

const CloseFilterIcon = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28 2L2 28" stroke="#425B76" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 2L28 28" stroke="#425B76" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default CloseFilterIcon;